// RankridgeHighlight.jsx
// A highly attractive, fully responsive React + Tailwind section
// Drop this component anywhere in your page. Uses brand color #20b2aa.
// No external UI libraries required.

import React from "react";

export default function RankridgeHighlight() {
  return (
    <section className="relative overflow-clip mt-4">
      {/* Decorative backdrop */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#20b2aa]/15 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-emerald-400/10 blur-3xl" />
      </div>

      {/* Hero */}
      <div className="mx-auto max-w-7xl px-4 py-1 sm:py-1 ">
        <div className="grid items-center gap-8 md:grid-cols-[1.2fr_.8fr]">
          <div className="border border-[#20b2aa] border-4 rounded-2xl shadow-2xl px-6">
            <span className="inline-flex items-center gap-2 rounded-full border border-teal-200 bg-white/70 px-3 py-1 text-xs font-medium text-teal-700 backdrop-blur">
              <Dot /> Trusted by parents across Hyderabad
            </span>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-neutral-900 sm:text-4xl">
              Why <span className="text-[#20b2aa]">Rankridge</span> is Among the Best Junior Colleges in Hyderabad
            </h2>
            <p className="mt-3 text-neutral-700">
              Parents choose Rankridge because we deliver consistent results year after year — backed by mentoring,
              analytics, and a genuine culture of care.
              </p>
              <p className="mt-3 text-neutral-700">
Parents choose Rankridge because we consistently deliver outstanding results year after year - powered by expert mentoring, data-driven analytics, personalized guidance, and a genuine culture of care that ensures every student’s academic success and confidence            </p>

            {/* Stats */}
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              <Stat kpi="State Toppers" sub="EAMCET" />
              <Stat kpi="100%" sub="IPE Success" />
              <Stat kpi="AIR Ranks" sub="JEE & NEET" />
              <Stat kpi="IITs/AIIMS" sub="Strong Alumni" />
            </div>

            {/* Highlights bullets */}
            <ul className="mt-6 space-y-2 text-sm text-neutral-700">
              <li className="flex items-start gap-2"><Check /> Proven track record of state‑level EAMCET toppers</li>
              <li className="flex items-start gap-2"><Check /> 100% success in Intermediate Public Examinations (IPE)</li>
              <li className="flex items-start gap-2"><Check /> Ranks in IIT‑JEE Advanced, IIT‑JEE Main, NEET & AIIMS</li>
              <li className="flex items-start gap-2"><Check /> Alumni at IIT Bombay, IIT Madras, NIT Warangal, AIIMS Delhi</li>
            </ul>

            <div className="mt-6 flex flex-wrap gap-3 mb-4">
              <Chip>Top Junior College for IIT‑JEE & NEET</Chip>
              <Chip>Mentor‑Driven Culture</Chip>
              <Chip>Student Care First</Chip>
            </div>
          </div>

          {/* Right card: Vision & Mission */}
          <div className="h-full border border-[#20b2aa] border-4 rounded-2xl shadow-2xl">
            <div className="h-full rounded-2xl border border-teal-100 bg-white p-5 shadow-sm">
              <h3 className="text-lg font-semibold text-neutral-900">Our Vision & Mission</h3>
              <div className="mt-3 space-y-3 text-sm text-neutral-700">
                <p><span className="font-semibold">Vision:</span> To be recognized as the best IIT‑JEE & NEET Junior College in Telangana & Andhra Pradesh, producing leaders, innovators, and achievers.</p>
                <div>
                  <p className="font-semibold text-neutral-900">Mission:</p>
                  <ul className="mt-2 list-disc ps-5 space-y-1">
                    <li>Provide world‑class IIT‑JEE & NEET coaching in Hyderabad</li>
                    <li>Blend Intermediate curriculum with competitive exam training</li>
                    <li>Offer stress‑free preparation with yoga, meditation & mentorship</li>
                    <li>Create future‑ready students with values, confidence & knowledge</li>
                  </ul>
                </div>
              </div>
              <div className="mt-5 rounded-xl bg-gradient-to-r from-[#20b2aa] to-emerald-500 p-[1px]">
                <div className="rounded-xl bg-white/90 p-3 text-sm">
                  <p className="flex items-center gap-2 text-neutral-800"><Spark /> When parents search for “Top Junior College in Hyderabad for IIT‑JEE & NEET”, Rankridge stands out for results, mentoring, and care.</p>
                </div>
              </div>

              <div className="mt-5 rounded-xl bg-gradient-to-r from-[#20b2aa] to-emerald-500 p-[1px]">
                <div className="rounded-xl bg-white/90 p-3 text-sm">
                  <p className="flex items-center gap-2 text-neutral-800"><Spark />Whenever students aim for IITs or AIIMS and parents seek the #1 junior college in Hyderabad for JEE & NEET, Rankridge shines through with its track record, mentorship, and holistic approach.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Expert Faculty */}
      <div className="mx-auto max-w-7xl px-4 pb-1 mt-4">
        <CardHeader
          overline="Faculty & Mentorship"
          title="Expert Faculty with Proven Experience"
          subtitle="Our faculty from IITs, NITs & AIIMS deliver national‑level standards with personal guidance."
        />
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <FeatureCard title="National‑level Standards" desc="Syllabus delivery tuned to JEE/NEET patterns & difficulty." />
          <FeatureCard title="Small Batches" desc="Focused attention and personalized improvement plans." />
          <FeatureCard title="24/7 Doubt Support" desc="Mentor desks and rapid doubt‑clearing channels." />
          <FeatureCard title="Personal Guidance" desc="Strategy to crack JEE Main/Advanced, NEET & EAMCET." />
        </div>
      </div>

      {/* RSM */}
      <div className="mx-auto max-w-7xl px-4 py-2">
        <CardHeader
          overline="RSM® Learning"
          title="Rankridge Smart Method (RSM®)"
          subtitle="A system that keeps students one step ahead."
        />
        <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <FeaturePill title="Daily & Weekly Tests" desc="Aligned with IIT‑JEE & NEET pattern to build exam muscle." />
          <FeaturePill title="AI‑Powered Analytics" desc="Track progress, pinpoint weak areas, and boost scores." />
          <FeaturePill title="Retention & Strategy" desc="Revision loops, mock drills, and time‑management tactics." />
          <FeaturePill title="Hybrid Learning" desc="Seamless online + offline coaching and resources." />
        </div>
        <div className="mt-5 rounded-xl border border-emerald-100 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
          RSM® makes Rankridge a top choice for <span className="font-semibold">MPC (IIT‑JEE)</span> and <span className="font-semibold">BiPC (NEET)</span> in Hyderabad.
        </div>
      </div>

      {/* Campus & Facilities */}
      <div className="mx-auto max-w-7xl px-4 py-2">
        <CardHeader
          overline="Campus & Care"
          title="Campus, Accommodation & Facilities"
          subtitle="A supportive environment designed for focused learning."
        />
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <Facility icon="🏫" title="Residential & Day‑Scholar" desc="Residential, semi‑residential, and day‑scholar programs." />
          <Facility icon="🔬" title="Modern Labs" desc="Physics, Chemistry, Biology & Math labs with safety protocols." />
          <Facility icon="🧠" title="Smart Classrooms" desc="Interactive boards and visual learning resources." />
          <Facility icon="🧘" title="Yoga & Wellness" desc="Yoga, sports & meditation for stress‑free prep." />
        </div>
      </div>

      {/* Culture of Care */}
      <div className="mx-auto max-w-7xl px-4 py-2">
        <CardHeader
          overline="Student‑First"
          title="Student‑Centric Culture of Care"
          subtitle="Care is as important as coaching at Rankridge."
        />
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <FeatureCard title="1:1 Mentorship" desc="Every student gets a mentor who tracks progress end‑to‑end." />
          <FeatureCard title="Parent Connect" desc="Regular PTMs with transparent performance dashboards." />
          <FeatureCard title="Stress Management" desc="Mindfulness, routines & confidence‑building modules." />
          <FeatureCard title="Alumni Motivation" desc="Rankers guide juniors with practical exam strategies." />
        </div>
      </div>

      {/* CTA Bar */}
      <div className="mx-auto max-w-7xl px-4 pb-14">
        <div className="flex flex-col items-start justify-between gap-4 rounded-2xl border border-teal-100 bg-white p-5 shadow-sm md:flex-row md:items-center">
          <div>
            <p className="text-lg font-semibold text-neutral-900">Ready to give your child an edge?</p>
            <p className="text-sm text-neutral-600">Apply for IIT‑JEE/NEET programs or book a free counseling session.</p>
          </div>
          <div className="flex w-full gap-3 md:w-auto">
            <a href="/apply" className="inline-flex flex-1 items-center justify-center rounded-xl bg-[#20b2aa] px-4 py-2 text-sm font-semibold text-white shadow hover:bg-teal-600 md:flex-none">Apply Now</a>
            <a href="/counseling" className="inline-flex flex-1 items-center justify-center rounded-xl border border-neutral-200 px-4 py-2 text-sm font-semibold text-neutral-800 hover:bg-neutral-50 md:flex-none">Book Counseling</a>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ======= Small UI helpers ======= */
function Dot(){
  return <span className="inline-block h-2 w-2 rounded-full bg-[#20b2aa]"/>;
}
function Check(){
  return (
    <svg className="mt-1 h-4 w-4 flex-none text-[#20b2aa]" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
      <path fillRule="evenodd" d="M16.704 5.29a1 1 0 010 1.415l-7.07 7.071a1 1 0 01-1.415 0L3.296 9.854a1 1 0 111.415-1.414l3.091 3.09 6.363-6.363a1 1 0 011.539.123z" clipRule="evenodd" />
    </svg>
  );
}
function Spark(){
  return (
    <svg className="h-4 w-4 text-amber-500" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M12 2l2.2 5.6L20 10l-5.6 2.2L12 18l-2.4-5.8L4 10l5.6-2.4L12 2z"/>
    </svg>
  );
}

function Chip({children}){
  return (
    <span className="rounded-full border border-teal-200 bg-white/70 px-3 py-1 text-xs font-medium text-teal-700 backdrop-blur">
      {children}
    </span>
  );
}

function Stat({kpi, sub}){
  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-3 text-center shadow-sm">
      <div className="text-lg font-bold text-neutral-900">{kpi}</div>
      <div className="text-xs text-neutral-500">{sub}</div>
    </div>
  );
}

function CardHeader({overline, title, subtitle}){
  return (
    <div className="text-center">
      <div className="text-xs  font-semibold uppercase tracking-wider text-[#20b2aa]">{overline}</div>
      <h3 className="mt-2 text-2xl font-bold text-neutral-900">{title}</h3>
      {subtitle && <p className="mt-1 text-neutral-600">{subtitle}</p>}
    </div>
  );
}

function FeatureCard({title, desc}){
  return (
    <div className="rounded-2xl border border-neutral-200 bg-white p-5 shadow-sm">
      <h4 className="text-sm font-semibold text-neutral-900">{title}</h4>
      <p className="mt-1 text-sm text-neutral-600">{desc}</p>
    </div>
  );
}

function FeaturePill({title, desc}){
  return (
    <div className="rounded-2xl border border-emerald-100 bg-emerald-50 p-5">
      <h4 className="text-sm font-semibold text-emerald-900">{title}</h4>
      <p className="mt-1 text-sm text-emerald-800/90">{desc}</p>
    </div>
  );
}

function Facility({icon, title, desc}){
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-neutral-200 bg-white p-5 shadow-sm">
      <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#20b2aa]/10 text-xl">{icon}</div>
      <div>
        <h4 className="text-sm font-semibold text-neutral-900">{title}</h4>
        <p className="mt-1 text-sm text-neutral-600">{desc}</p>
      </div>
    </div>
  );
}
